import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import PowerPersonalizationImage from './PowerPersonalizationImage'

const copy = {
  heading: `Power personalization with Profile API`,
  description: `Query your user profile in real time to build in-app recommendations, empower your sales and support teams with complete customer context, and create personalized marketing campaigns.`,
}

const PowerPersonalization: FC = () => (
  <StyledSectionBase variant="2Col" reverse={true}>
    <Section.Contents>
      <PowerPersonalizationImage alt={`Illustration: ${copy.heading}`} />
    </Section.Contents>
    <StyledCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading tag="h2" variant="h2">
          {copy.heading}
        </CopyText.Heading>
        <CopyText.Description tag="p" variant="pLarge">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </StyledCopy>
  </StyledSectionBase>
)

export default PowerPersonalization

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
